import { Component, ChangeDetectionStrategy } from "@angular/core";
import { SharedModule, TypedBaseListComponent } from "@bb-vendure/admin-ui/core";
import { GetPushNotificationsDocument } from "src/generated-gql/graphql";
@Component({
  selector: "noti-campaigns",
  templateUrl: "./list.components.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export default class NotiCampaignsComponent extends TypedBaseListComponent<
  typeof GetPushNotificationsDocument,
  "getPushNotifications"
> {
  constructor() {
    super();
    super.configure({
      document: GetPushNotificationsDocument,
      getItems: (data) => {
        console.log(data);
        return data.getPushNotifications;
      },
      setVariables: (skip,take) => ({
        options: {
          skip,take,
          filter: {
            title: {
              contains: this.searchTermControl.value,
            },
            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        }
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ]
    })
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .addFilter({
      name: "title",
      type: { kind: "text" },
      label: "Title",
      filterField: "title",
    })
    .addFilter({
      name: "isDevelopment",
      type: { kind: "boolean" },
      label: "Development Push",
      filterField: "isDevelopment",
    })
    .addFilter({
      name: "scheduledTime",
      type: { kind: "dateRange" },
      label: "Scheduled Time",
      filterField: "scheduledTime",
    })
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSort({ name: "createdAt" })
    .addSort({ name: "updatedAt" })
    .addSort({ name: "title" })
    .addSort({ name: "scheduledTime" })
    .connectToRoute(this.route);
}
